<template>
  <div class="empty-state">
    <div class="empty-icon">{{ icon }}</div>
    <h3 class="empty-title">{{ title }}</h3>
    <p v-if="description" class="empty-desc">{{ description }}</p>
    <button v-if="actionLabel" class="btn-primary" @click="$emit('action')">{{ actionLabel }}</button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: '✨' },
    title: { type: String, required: true },
    description: { type: String, default: '' },
    actionLabel: { type: String, default: null }
  },
  emits: ['action']
}
</script>

<style scoped>
.empty-state {
  display: flex; flex-direction: column; align-items: center;
  padding: var(--spacing-xl);
  text-align: center; gap: var(--spacing-md);
}
.empty-icon { font-size: 48px; }
.empty-title { font-size: var(--text-lg); color: var(--color-text-primary); font-weight: 600; }
.empty-desc { color: var(--color-text-muted); font-size: var(--text-sm); max-width: 380px; }
</style>
